import { focusManager, QueryClient } from '@tanstack/react-query';
import { RelevanceTestsService } from 'src/services/RelevanceTestsService';
import { ButtonGroupOptions } from '../../ButtonGroupWithPopper';

const MAX_CONCURRENCY = 20;

export async function runComparisons(
    accessToken: string | false,
    queryClient: QueryClient,
    options: ButtonGroupOptions,
    onProgress: (value: number) => void,
    showToast: (message: string) => void,
): Promise<Models.IngestConfigApi.RelevanceTests.RelevanceComparisonResult[]> {
    focusManager.setFocused(false);

    try {
        const testDefinitionIds = await queryClient.fetchQuery(
            ['relevance_test_definition_ids', accessToken],
            () => RelevanceTestsService.getRelevanceTestDefinitionIds(accessToken),
        );

        const total = testDefinitionIds.length;
        let completed = 0;
        const allResults: Models.IngestConfigApi.RelevanceTests.RelevanceComparisonResult[] = [];

        for (let i = 0; i < total; i += MAX_CONCURRENCY) {
            const batch = testDefinitionIds.slice(i, i + MAX_CONCURRENCY);

            // eslint-disable-next-line no-await-in-loop
            const batchResults = await Promise.allSettled(
                batch.map((testDefinitionId) => queryClient.fetchQuery(
                    [
                        'compare_relevance_test_definition',
                        accessToken,
                        {
                            testDefinitionId,
                            experimentFlags: options.experimentFlags,
                            searchBackend: options.searchBackend,
                        },
                    ],
                    () => RelevanceTestsService.compareRelevanceTestDefinition(
                        accessToken,
                        testDefinitionId,
                        options.experimentFlags,
                        options.searchBackend,
                    ),
                )),
            );
            // eslint-disable-next-line no-await-in-loop

            for (let j = 0; j < batchResults.length; j += 1) {
                const res = batchResults[j];

                if (res.status === 'fulfilled') {
                    allResults.push(res.value);
                } else {
                    const failedId = batch[j];

                    showToast(`Comparison failed for test definition ${failedId}`);
                }

                completed += 1;
                onProgress(Math.round((completed / total) * 100));
            }
        }

        return allResults;
    } finally {
        focusManager.setFocused(true);
    }
}
